<svg [attr.width]="size" [attr.height]="size" [attr.viewBox]="viewBox" fill="none" aria-hidden="true">
  @switch (name) {
    @case ("search") {
      <circle cx="6.8" cy="6.8" r="4.8" stroke="currentColor" stroke-width="1.6" />
      <line x1="10.4" y1="10.4" x2="14" y2="14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    }
    @case ("chevron-down") {
      <path d="M4 6.2L8 10.2L12 6.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("check") {
      <path d="M3.3 8.5L6.4 11.6L12.7 4.7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("checkmark-circle") {
      <circle cx="8" cy="8" r="6.3" stroke="currentColor" stroke-width="1.4" />
      <path d="M5.3 8.2L7.1 10L10.8 5.9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("check-circle-filled") {
      <circle cx="8" cy="8" r="7" fill="currentColor" />
      <path d="M4.8 8.1L7 10.2L11.3 5.7" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("close") {
      <path d="M4 4L12 12M12 4L4 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    }
    @case ("kyc-status") {
      <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.4" />
      <path d="M5.2 8.2L7 10L10.8 5.8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("toggle") {
      <rect x="1.5" y="4.5" width="13" height="7" rx="3.5" stroke="currentColor" stroke-width="1.3" />
      <circle cx="10.5" cy="8" r="2.3" fill="currentColor" />
    }
    @case ("layers") {
      <path d="M8 2L14 5.4L8 8.8L2 5.4L8 2Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
      <path d="M2 8.4L8 11.8L14 8.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M2 11L8 14.4L14 11" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("filter") {
      <path
        d="M2.5 3.5h11L9.25 8.75v4.25L6.75 14.25V8.75L2.5 3.5Z"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    }
    @case ("filter-horizontal") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 7h3M3 17h6m9 0h3M15 7h6" />
        <path
          d="M6 7c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C7.602 4 8.068 4 9 4s1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C12 5.602 12 6.068 12 7s0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C10.398 10 9.932 10 9 10s-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C6 8.398 6 7.932 6 7Zm6 10c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C13.602 14 14.068 14 15 14s1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C18 15.602 18 16.068 18 17s0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C16.398 20 15.932 20 15 20s-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C12 18.398 12 17.932 12 17Z"
        />
      </g>
    }
    @case ("plus") {
      <path d="M8 2.5V13.5M2.5 8H13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
    }
    @case ("wallet") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M13 3.5h1c.93 0 1.395 0 1.777.102a3 3 0 0 1 2.12 2.122C18 6.105 18 6.57 18 7.5H5a2 2 0 1 1 0-4h3" />
        <path d="M3 5.5v10c0 2.828 0 4.243.879 5.121c.878.879 2.293.879 5.121.879h6c2.828 0 4.243 0 5.121-.879C21 19.743 21 18.328 21 15.5v-2c0-2.828 0-4.243-.879-5.121C19.243 7.5 17.828 7.5 15 7.5H7" />
        <path d="M21 12.5h-2c-.465 0-.698 0-.888.051a1.5 1.5 0 0 0-1.06 1.06c-.052.191-.052.424-.052.889s0 .697.051.888a1.5 1.5 0 0 0 1.06 1.06c.191.052.424.052.889.052h2m-10.5-14a3.5 3.5 0 0 1 3.163 5H7.337a3.5 3.5 0 0 1 3.163-5" />
      </g>
    }
    @case ("gift") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round">
        <path stroke-linecap="round" d="M4 11v4c0 3.3 0 4.95 1.025 5.975S7.7 22 11 22h2c3.3 0 4.95 0 5.975-1.025S20 18.3 20 15v-4" />
        <path d="M3 9c0-.748 0-1.122.201-1.4a1.4 1.4 0 0 1 .549-.44C4.098 7 4.565 7 5.5 7h13c.935 0 1.402 0 1.75.16c.228.106.417.258.549.44C21 7.878 21 8.252 21 9s0 1.121-.201 1.4a1.4 1.4 0 0 1-.549.44c-.348.16-.815.16-1.75.16h-13c-.935 0-1.402 0-1.75-.16a1.4 1.4 0 0 1-.549-.44C3 10.121 3 9.748 3 9Zm3-5.214C6 2.799 6.8 2 7.786 2h.357A3.857 3.857 0 0 1 12 5.857V7H9.214A3.214 3.214 0 0 1 6 3.786Zm12 0C18 2.799 17.2 2 16.214 2h-.357A3.857 3.857 0 0 0 12 5.857V7h2.786A3.214 3.214 0 0 0 18 3.786Z" />
        <path stroke-linecap="round" d="M12 11v11" />
      </g>
    }
    @case ("money-bag") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round">
        <path stroke-linecap="round" d="M20.943 16.835a15.76 15.76 0 0 0-4.476-8.616c-.517-.503-.775-.754-1.346-.986C14.55 7 14.059 7 13.078 7h-2.156c-.981 0-1.472 0-2.043.233c-.57.232-.83.483-1.346.986a15.76 15.76 0 0 0-4.476 8.616C2.57 19.773 5.28 22 8.308 22h7.384c3.029 0 5.74-2.227 5.25-5.165" />
        <path d="M7.257 4.443c-.207-.3-.506-.708.112-.8c.635-.096 1.294.338 1.94.33c.583-.009.88-.268 1.2-.638C10.845 2.946 11.365 2 12 2s1.155.946 1.491 1.335c.32.37.617.63 1.2.637c.646.01 1.305-.425 1.94-.33c.618.093.319.5.112.8l-.932 1.359c-.4.58-.599.87-1.017 1.035S13.837 7 12.758 7h-1.516c-1.08 0-1.619 0-2.036-.164S8.589 6.38 8.189 5.8z" />
        <path stroke-linecap="round" d="M13.627 12.919c-.216-.799-1.317-1.519-2.638-.98s-1.53 2.272.467 2.457c.904.083 1.492-.097 2.031.412c.54.508.64 1.923-.739 2.304c-1.377.381-2.742-.214-2.89-1.06m1.984-5.06v.761m0 5.476v.764" />
      </g>
    }
    @case ("invoice") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 18.646V8.054c0-2.854 0-4.28.879-5.167C5.757 2 7.172 2 10 2h4c2.828 0 4.243 0 5.121.887C20 3.773 20 5.2 20 8.054v10.592c0 1.511 0 2.267-.462 2.565c-.755.486-1.922-.534-2.509-.904c-.485-.306-.727-.458-.997-.467c-.29-.01-.537.137-1.061.467l-1.911 1.205c-.516.325-.773.488-1.06.488s-.544-.163-1.06-.488l-1.91-1.205c-.486-.306-.728-.458-.997-.467c-.291-.01-.538.137-1.062.467c-.587.37-1.754 1.39-2.51.904C4 20.913 4 20.158 4 18.646M11 11H8m6-4H8" />
      </g>
    }
    @case ("user-circle") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M15.5 10.5a3.5 3.5 0 1 0-7 0a3.5 3.5 0 0 0 7 0" />
        <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10s10-4.477 10-10" />
        <path d="M18 20a6 6 0 0 0-12 0" />
      </g>
    }
    @case ("user-multiple") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M13 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0Z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a4 4 0 0 0 0-8" />
        <path stroke-linejoin="round" d="M11 14H7a5 5 0 0 0-5 5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2a5 5 0 0 0-5-5Z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M17 14a5 5 0 0 1 5 5a2 2 0 0 1-2 2h-1.5" />
      </g>
    }
    @case ("user-settings") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14.5 7.5a5 5 0 1 0-10 0a5 5 0 0 0 10 0" />
        <path d="M2.5 19.5a7 7 0 0 1 10-6.326M18 20c.93 0 1.74-.507 2.171-1.26M18 20c-.93 0-1.74-.507-2.171-1.26M18 20v1.5m0-6.5c.93 0 1.74.507 2.17 1.26M18 15c-.93 0-1.74.507-2.17 1.26M18 15v-1.5m3.5 2l-1.33.76M14.5 19.5l1.329-.76m5.671.76l-1.329-.76M14.5 15.5l1.33.76m4.34 0c.21.365.33.788.33 1.24s-.12.875-.329 1.24m-4.342 0a2.5 2.5 0 0 1-.329-1.24c0-.451.12-.875.33-1.24" />
      </g>
    }
    @case ("chart-line") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5">
        <circle cx="8.5" cy="10.5" r="1.5" />
        <circle cx="14.5" cy="15.5" r="1.5" />
        <circle cx="18.5" cy="7.5" r="1.5" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.434 14.296L18 9m-8.417 2.568l3.62 2.728M3 19l4.59-7.12" />
        <path stroke-linecap="round" d="M20 21H9c-3.3 0-4.95 0-5.975-1.025S2 17.3 2 14V3" />
      </g>
    }
    @case ("transfer") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 9H6.659c-1.006 0-1.51 0-1.634-.309c-.125-.308.23-.672.941-1.398L8.211 5M5 15h12.341c1.006 0 1.51 0 1.634.309c.125.308-.23.672-.941 1.398L15.789 19" />
      </g>
    }
    @case ("exchange") {
      <!-- hugeicons exchange-01 (stroke rounded) -->
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M16.9767 19.5C19.4017 17.8876 21 15.1305 21 12C21 7.02944 16.9706 3 12 3C11.3126 3 10.6432 3.07706 10 3.22302M16.9767 19.5V16M16.9767 19.5H20.5M7 4.51555C4.58803 6.13007 3 8.87958 3 12C3 16.9706 7.02944 21 12 21C12.6874 21 13.3568 20.9229 14 20.777M7 4.51555V8M7 4.51555H3.5" />
      </g>
    }
    @case ("bank") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12.125 5.75H12m.25 0a.25.25 0 1 1-.5 0a.25.25 0 0 1 .5 0M5 9v10M9 9v10m6-10v10m4-10v10" />
        <path d="M21.352 9H2.648a.657.657 0 0 1-.353-1.205l6.435-4.23C10.317 2.522 11.11 2 12 2s1.683.522 3.27 1.565l6.435 4.23A.658.658 0 0 1 21.352 9m-.312 11.293l-.688-.707c-.281-.29-.422-.434-.6-.51c-.18-.076-.378-.076-.776-.076H5.024c-.398 0-.597 0-.775.076c-.18.076-.32.22-.6.51l-.689.707c-.706.726-1.06 1.09-.935 1.398c.124.309.624.309 1.623.309h16.704c1 0 1.5 0 1.623-.309c.125-.308-.229-.672-.935-1.398" />
      </g>
    }
    @case ("unfold-more") {
      <path d="M5 6.5L8 3.5L11 6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5 9.5L8 12.5L11 9.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("help-circle") {
      <circle cx="8" cy="8" r="6.3" stroke="currentColor" stroke-width="1.4" />
      <path d="M6.2 6.3C6.2 5.1 7 4.3 8.1 4.3C9.2 4.3 10 5 10 6C10 7.5 8.1 7.3 8.1 9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx="8.1" cy="11.2" r="0.9" fill="currentColor" />
    }
    @case ("arrow-right") {
      <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("arrow-left") {
      <path d="M13 8H3.5M6.5 4.5L3 8L6.5 11.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("home") {
      <path d="M2.5 7.5L8 2.8L13.5 7.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4 6.5V13H12V6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.5 13V9.5H9.5V13" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("notification") {
      <path
        d="M8 2.5C6 2.5 4.8 4 4.8 6V8.5C4.8 9.5 4.3 10.2 3.7 10.8C3.4 11.1 3.6 11.6 4 11.6H12C12.4 11.6 12.6 11.1 12.3 10.8C11.7 10.2 11.2 9.5 11.2 8.5V6C11.2 4 10 2.5 8 2.5Z"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linejoin="round"
      />
      <path d="M6.5 13.2C6.8 13.9 7.3 14.3 8 14.3C8.7 14.3 9.2 13.9 9.5 13.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("grid") {
      <rect x="2.2" y="2.2" width="4.8" height="4.8" rx="1" stroke="currentColor" stroke-width="1.3" />
      <rect x="9" y="2.2" width="4.8" height="4.8" rx="1" stroke="currentColor" stroke-width="1.3" />
      <rect x="2.2" y="9" width="4.8" height="4.8" rx="1" stroke="currentColor" stroke-width="1.3" />
      <rect x="9" y="9" width="4.8" height="4.8" rx="1" stroke="currentColor" stroke-width="1.3" />
    }
    @case ("money-add") {
      <rect x="1.5" y="4" width="13" height="9" rx="2" stroke="currentColor" stroke-width="1.3" />
      <path d="M11 8V10.4M9.8 9.2H12.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("money-send") {
      <rect x="1.5" y="4" width="13" height="9" rx="2" stroke="currentColor" stroke-width="1.3" />
      <path d="M9.8 9.2H12.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("wallet-add") {
      <rect x="1.5" y="4" width="13" height="9" rx="2" stroke="currentColor" stroke-width="1.3" />
      <path d="M1.5 6.6H14.5" stroke="currentColor" stroke-width="1.3" />
      <path d="M11 8.6V11M9.8 9.8H12.2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    }
    @case ("pause") {
      <rect x="4" y="3" width="2.6" height="10" rx="1" stroke="currentColor" stroke-width="1.2" />
      <rect x="9.4" y="3" width="2.6" height="10" rx="1" stroke="currentColor" stroke-width="1.2" />
    }
    @case ("cancel-circle") {
      <circle cx="8" cy="8" r="6.3" stroke="currentColor" stroke-width="1.4" />
      <path d="M5.8 5.8L10.2 10.2M10.2 5.8L5.8 10.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("credit-card") {
      <rect x="1.5" y="3.5" width="13" height="9" rx="1.6" stroke="currentColor" stroke-width="1.3" />
      <path d="M1.5 6.5H14.5" stroke="currentColor" stroke-width="1.3" />
      <path d="M3.5 9.8H6.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    }
    @case ("restaurant") {
      <path d="M4.5 2V8.5M3 2V5.2C3 6 3.7 6.6 4.5 6.6C5.3 6.6 6 6 6 5.2V2" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" />
      <path d="M4.5 8.5V14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
      <path d="M11.5 2C10.2 2 9.5 3.5 9.5 5.5C9.5 6.8 10 7.5 11 7.8V14" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("fuel-station") {
      <rect x="2" y="3" width="6.5" height="11" rx="1" stroke="currentColor" stroke-width="1.2" />
      <path d="M2 8.5H8.5" stroke="currentColor" stroke-width="1.1" />
      <path d="M8.5 6.5L11 8V11.5C11 12.2 11.6 12.8 12.3 12.8C13 12.8 13.5 12.2 13.5 11.5V8.2C13.5 7.6 13.2 7.1 12.7 6.8L11 5.8" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("airplane") {
      <path
        d="M8 1.5L9.5 3V6.3L13.8 8.8V10.2L9.5 8.9V11.8L11 13V14.2L8 13.3L5 14.2V13L6.5 11.8V8.9L2.2 10.2V8.8L6.5 6.3V3L8 1.5Z"
        stroke="currentColor"
        stroke-width="1.1"
        stroke-linejoin="round"
      />
    }
    @case ("wifi") {
      <path d="M2.5 6.3C5.8 3.2 10.2 3.2 13.5 6.3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M4.6 8.7C6.5 6.9 9.5 6.9 11.4 8.7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M6.7 11.1C7.9 10 8.1 10 9.3 11.1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <circle cx="8" cy="13" r="0.9" fill="currentColor" />
    }
    @case ("wallet-01") {
      <rect x="1.5" y="4" width="13" height="9" rx="2" stroke="currentColor" stroke-width="1.4" />
      <path d="M1.5 6.6H14.5" stroke="currentColor" stroke-width="1.4" />
    }
    @case ("wallet-02") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M13 3.5h1c.93 0 1.395 0 1.777.102a3 3 0 0 1 2.12 2.122C18 6.105 18 6.57 18 7.5H5a2 2 0 1 1 0-4h3" />
        <path d="M3 5.5v10c0 2.828 0 4.243.879 5.121c.878.879 2.293.879 5.121.879h6c2.828 0 4.243 0 5.121-.879C21 19.743 21 18.328 21 15.5v-2c0-2.828 0-4.243-.879-5.121C19.243 7.5 17.828 7.5 15 7.5H7" />
        <path d="M21 12.5h-2c-.465 0-.698 0-.888.051a1.5 1.5 0 0 0-1.06 1.06c-.052.191-.052.424-.052.889s0 .697.051.888a1.5 1.5 0 0 0 1.06 1.06c.191.052.424.052.889.052h2m-10.5-14a3.5 3.5 0 0 1 3.163 5H7.337a3.5 3.5 0 0 1 3.163-5" />
      </g>
    }
    @case ("refresh") {
      <path d="M13 8C13 5.2 10.8 3 8 3C6 3 4.3 4.2 3.5 5.9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M3.5 3V6H6.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3 8C3 10.8 5.2 13 8 13C10 13 11.7 11.8 12.5 10.1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M12.5 13V10H9.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("loading-03") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
        <path d="M12 3V6" />
        <path d="M12 18V21" />
        <path d="M21 12L18 12" />
        <path d="M6 12L3 12" />
        <path d="M18.3635 5.63672L16.2422 7.75804" />
        <path d="M7.75804 16.2422L5.63672 18.3635" />
        <path d="M18.3635 18.3635L16.2422 16.2422" />
        <path d="M7.75804 7.75804L5.63672 5.63672" />
      </g>
    }
    @case ("qr-code") {
      <rect x="2" y="2" width="4.5" height="4.5" rx="0.6" stroke="currentColor" stroke-width="1.2" />
      <rect x="9.5" y="2" width="4.5" height="4.5" rx="0.6" stroke="currentColor" stroke-width="1.2" />
      <rect x="2" y="9.5" width="4.5" height="4.5" rx="0.6" stroke="currentColor" stroke-width="1.2" />
      <rect x="9.7" y="9.7" width="1.8" height="1.8" fill="currentColor" />
      <rect x="12.3" y="9.7" width="1.8" height="1.8" fill="currentColor" />
      <rect x="9.7" y="12.3" width="1.8" height="1.8" fill="currentColor" />
    }
    @case ("information-circle") {
      <circle cx="8" cy="8" r="6.3" stroke="currentColor" stroke-width="1.4" />
      <circle cx="8" cy="5.4" r="0.9" fill="currentColor" />
      <path d="M8 7.6V11.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("lock") {
      <rect x="3.5" y="7" width="9" height="7" rx="1.4" stroke="currentColor" stroke-width="1.3" />
      <path d="M5.2 7V5C5.2 3.5 6.4 2.3 8 2.3C9.6 2.3 10.8 3.5 10.8 5V7" stroke="currentColor" stroke-width="1.3" />
      <circle cx="8" cy="10.3" r="1" fill="currentColor" />
    }
    @case ("unlock") {
      <rect x="3.5" y="7" width="9" height="7" rx="1.4" stroke="currentColor" stroke-width="1.3" />
      <path d="M5.2 7V5C5.2 3.5 6.4 2.3 8 2.3C9.4 2.3 10.6 3.3 10.8 4.6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <circle cx="8" cy="10.3" r="1" fill="currentColor" />
    }
    @case ("building") {
      <g transform="scale(0.66667)" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="m16 10l2.15.645c1.373.412 2.06.618 2.455 1.15c.395.53.395 1.248.395 2.681V22" />
        <path d="M8 9h3m-3 4h3" />
        <path d="M12 22v-3c0-.943 0-1.414-.293-1.707S10.943 17 10 17H9c-.943 0-1.414 0-1.707.293S7 18.057 7 19v3" />
        <path d="M2 22h20" />
        <path d="M3 22V6.717c0-2.51 0-3.766.791-4.389s1.956-.284 4.287.392l5 1.451c1.406.408 2.109.612 2.515 1.169C16 5.896 16 6.653 16 8.169V22" />
      </g>
    }
    @case ("arrow-down-left") {
      <path d="M12 4L5 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      <path d="M5 6.2V11H9.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("arrow-circle-down") {
      <circle cx="8" cy="8" r="7" fill="currentColor" />
      <path d="M8 4.5V10.5" stroke="#fff" stroke-width="1.6" stroke-linecap="round" />
      <path d="M5.4 8.2L8 10.8L10.6 8.2" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("arrow-up-right") {
      <path d="M4 12L11 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      <path d="M6.2 5H11V9.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("download") {
      <path
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 3v12m-5-5 5 5 5-5"
      />
      <path
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M5 16.5V19a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2.5"
      />
    }
    @case ("clock") {
      <circle cx="8" cy="8" r="6.3" stroke="currentColor" stroke-width="1.4" />
      <path d="M8 4.7V8.2L10.4 9.8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("alert") {
      <path d="M8 1.8L14.5 13.4H1.5L8 1.8Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
      <path d="M8 6.3V9.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <circle cx="8" cy="11.4" r="0.85" fill="currentColor" />
    }
    @case ("warning") {
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.13 2.2c.38-.68 1.36-.68 1.74 0l5.98 10.85c.38.68-.11 1.55-.87 1.55H2.02c-.76 0-1.25-.87-.87-1.55L7.13 2.2ZM8 5.85c.39 0 .7.31.7.7v3.15a.7.7 0 1 1-1.4 0V6.55c0-.39.31-.7.7-.7Zm0 6.4a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z"
      />
    }
    @case ("error") {
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5.35 1.7h5.3L14.3 5.35v5.3L10.65 14.3h-5.3L1.7 10.65v-5.3L5.35 1.7ZM8 5.15c.39 0 .7.31.7.7v3.05a.7.7 0 1 1-1.4 0V5.85c0-.39.31-.7.7-.7Zm0 6.35a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z"
      />
    }
    @case ("copy") {
      <rect x="5.6" y="5.6" width="8" height="8.4" rx="1.3" stroke="currentColor" stroke-width="1.2" />
      <path d="M3.4 10.4C2.7 10.1 2.2 9.4 2.2 8.6V3.9C2.2 2.9 3 2.1 4 2.1H8.7C9.5 2.1 10.2 2.6 10.5 3.3" stroke="currentColor" stroke-width="1.2" />
    }
    @case ("edit") {
      <path d="M10.2 2.8L13.2 5.8L5.5 13.5L2 14L2.5 10.5L10.2 2.8Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" />
      <path d="M8.8 4.2L11.8 7.2" stroke="currentColor" stroke-width="1.1" />
    }
    @case ("eye") {
      <path d="M1.5 8C3 5.2 5.3 3.8 8 3.8C10.7 3.8 13 5.2 14.5 8C13 10.8 10.7 12.2 8 12.2C5.3 12.2 3 10.8 1.5 8Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
      <circle cx="8" cy="8" r="2.1" stroke="currentColor" stroke-width="1.2" />
    }
    @case ("time") {
      <circle cx="8" cy="8.5" r="5.6" stroke="currentColor" stroke-width="1.3" />
      <path d="M8 5.6V8.5L10 9.9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6 1.5H10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    }
    @case ("zoom-in") {
      <circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.3" />
      <path d="M7 4.7V9.3M4.7 7H9.3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
      <line x1="10.6" y1="10.6" x2="14" y2="14" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("zoom-out") {
      <circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.3" />
      <path d="M4.7 7H9.3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
      <line x1="10.6" y1="10.6" x2="14" y2="14" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("expand") {
      <path d="M2 6V2H6M10 2H14V6M14 10V14H10M6 14H2V10" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("file") {
      <path d="M4 2H9.5L12 4.5V14H4V2Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
      <path d="M9.5 2V4.5H12" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" />
      <path d="M6 8H10M6 10.5H10" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" />
    }
    @case ("clipboard") {
      <rect x="3.2" y="3.6" width="9.6" height="11" rx="1.5" stroke="currentColor" stroke-width="1.3" />
      <circle cx="5.2" cy="2.8" r="1.05" stroke="currentColor" stroke-width="1.15" />
      <circle cx="8" cy="2.8" r="1.05" stroke="currentColor" stroke-width="1.15" />
      <circle cx="10.8" cy="2.8" r="1.05" stroke="currentColor" stroke-width="1.15" />
      <path d="M5.4 7.4H10.6M5.4 10H9.2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    }
    @case ("link") {
      <path d="M6.8 9.2L9.2 6.8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M8 5.3L9.3 4C10.4 2.9 12.1 2.9 13.1 4C14.2 5 14.2 6.7 13.1 7.8L11.8 9.1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M8 10.7L6.7 12C5.6 13.1 3.9 13.1 2.9 12C1.8 11 1.8 9.3 2.9 8.2L4.2 6.9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("receipt") {
      <path d="M4 2H12V14L10.3 12.8L8.7 14L7 12.8L5.3 14L3.7 12.8L4 14V2Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" />
      <path d="M6 5.5H10M6 8H10M6 10.3H8.5" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" />
    }
    @case ("shield") {
      <path d="M8 1.8L13.5 4V8C13.5 11.3 11.2 13.7 8 14.5C4.8 13.7 2.5 11.3 2.5 8V4L8 1.8Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
      <path d="M5.6 8.1L7.3 9.8L10.6 6.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("message") {
      <path
        d="M8 2.4C4.95 2.4 2.5 4.7 2.5 7.5C2.5 9.55 3.75 11.3 5.65 12.15L4.1 14.35L7.15 13C7.4 13.05 7.7 13.1 8 13.1C11.05 13.1 13.5 10.8 13.5 7.5C13.5 4.7 11.05 2.4 8 2.4Z"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linejoin="round"
      />
      <path d="M5.5 6.3H10.5M5.5 8.7H9.1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
    }
    @case ("globe") {
      <circle cx="8" cy="8" r="6.3" stroke="currentColor" stroke-width="1.3" />
      <path d="M1.7 8H14.3M8 1.7C9.7 3.5 10.6 5.7 10.6 8C10.6 10.3 9.7 12.5 8 14.3C6.3 12.5 5.4 10.3 5.4 8C5.4 5.7 6.3 3.5 8 1.7Z" stroke="currentColor" stroke-width="1.2" />
    }
    @case ("chevron-up") {
      <path d="M4 9.8L8 5.8L12 9.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    }
    @case ("book") {
      <path d="M2.5 3.2C4 2.5 6 2.5 8 3.4V13.2C6 12.3 4 12.3 2.5 13V3.2Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" />
      <path d="M13.5 3.2C12 2.5 10 2.5 8 3.4V13.2C10 12.3 12 12.3 13.5 13V3.2Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" />
    }
    @case ("calendar") {
      <rect x="2" y="3.2" width="12" height="10.8" rx="1.6" stroke="currentColor" stroke-width="1.3" />
      <line x1="2" y1="6.4" x2="14" y2="6.4" stroke="currentColor" stroke-width="1.3" />
      <line x1="5" y1="1.8" x2="5" y2="4.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <line x1="11" y1="1.8" x2="11" y2="4.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("car") {
      <path
        d="M2.3 11.2V8.7C2.3 8.4 2.4 8.1 2.6 7.9L4.1 6.1C4.4 5.7 4.9 5.5 5.4 5.5H10.6C11.1 5.5 11.6 5.7 11.9 6.1L13.4 7.9C13.6 8.1 13.7 8.4 13.7 8.7V11.2"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect x="1.6" y="9.4" width="12.8" height="3" rx="1.1" stroke="currentColor" stroke-width="1.3" />
      <path d="M2.3 7.6H13.7" stroke="currentColor" stroke-width="1.2" />
      <circle cx="4.8" cy="12.6" r="1.2" fill="currentColor" />
      <circle cx="11.2" cy="12.6" r="1.2" fill="currentColor" />
    }
    @case ("store") {
      <path d="M2 6.5L2.8 2.5H13.2L14 6.5" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
      <path
        d="M2.3 6.5C2.3 7.5 3.1 8.2 4 8.2C4.9 8.2 5.7 7.5 5.7 6.5C5.7 7.5 6.5 8.2 7.4 8.2C8.3 8.2 9 7.5 9 6.5C9 7.5 9.8 8.2 10.6 8.2C11.5 8.2 12.3 7.5 12.3 6.5C12.3 7.5 13.1 8.2 13.7 8.2"
        stroke="currentColor"
        stroke-width="1.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M3 8V13.5H13V8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.3 13.5V10H9.7V13.5" stroke="currentColor" stroke-width="1.2" />
    }
    @case ("tags") {
      <path d="M2.5 2.5H7L13 8.5L8.5 13L2.5 7V2.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" />
      <circle cx="5" cy="5" r="0.9" fill="currentColor" />
    }
    @case ("upload") {
      <path d="M8 10V2.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
      <path d="M5 5L8 2L11 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3 12.5H13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
    }
    @case ("unlink") {
      <path d="M8 5.3L9.3 4C10.4 2.9 12.1 2.9 13.1 4C14.2 5 14.2 6.7 13.1 7.8L11.8 9.1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M8 10.7L6.7 12C5.6 13.1 3.9 13.1 2.9 12C1.8 11 1.8 9.3 2.9 8.2L4.2 6.9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M2 2L14 14" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("shopping-basket") {
      <path d="M3 6H13L12 13.5H4L3 6Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" />
      <path d="M5.5 6C5.5 4 6.6 2.5 8 2.5C9.4 2.5 10.5 4 10.5 6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
      <path d="M6 8.5V11M8 8.5V11M10 8.5V11" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
    }
    @case ("truck") {
      <rect x="1.5" y="5" width="7" height="6.5" rx="0.8" stroke="currentColor" stroke-width="1.2" />
      <path d="M8.5 7H11.3L13.5 9.3V11.5H8.5V7Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" />
      <circle cx="4.5" cy="12.2" r="1.2" fill="currentColor" />
      <circle cx="11" cy="12.2" r="1.2" fill="currentColor" />
    }
    @case ("wrench") {
      <path
        d="M10.8 2.6C9.5 2.6 8.4 3.7 8.4 5C8.4 5.3 8.5 5.6 8.6 5.9L2.8 11.7C2.3 12.2 2.3 13 2.8 13.5C3.3 14 4.1 14 4.6 13.5L10.4 7.7C10.7 7.8 11 7.9 11.3 7.9C12.6 7.9 13.7 6.8 13.7 5.5C13.7 5.1 13.6 4.8 13.5 4.5L11.7 6.3L10.2 4.8L11.9 3.1C11.6 2.8 11.2 2.6 10.8 2.6Z"
        stroke="currentColor"
        stroke-width="1.1"
        stroke-linejoin="round"
      />
    }
    @case ("medicine") {
      <circle cx="8" cy="8" r="6.3" stroke="currentColor" stroke-width="1.3" />
      <path d="M8 5.2V10.8M5.2 8H10.8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("energy") {
      <path d="M8.7 1.8L3.5 9.2H7.3L6.3 14.2L12.5 6.4H8.5L8.7 1.8Z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round" />
    }
    @case ("megaphone") {
      <path d="M2 6.5V9.5L4 10V6L2 6.5Z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round" />
      <path d="M4 6L11 3V13L4 10V6Z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round" />
      <path d="M11 5.5C12.2 5.8 13 6.8 13 8C13 9.2 12.2 10.2 11 10.5" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" />
      <path d="M4.5 10.2L5.5 13.5" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" />
    }
    @case ("trash") {
      <path d="M2.5 4.2H13.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M6 4.2V2.9C6 2.6 6.2 2.4 6.5 2.4H9.5C9.8 2.4 10 2.6 10 2.9V4.2" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
      <path d="M3.8 4.2L4.4 12.8C4.4 13.2 4.8 13.6 5.2 13.6H10.8C11.2 13.6 11.6 13.2 11.6 12.8L12.2 4.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.6 6.8V11M9.4 6.8V11" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("user-add") {
      <circle cx="6.5" cy="5.2" r="2.6" stroke="currentColor" stroke-width="1.3" />
      <path d="M1.8 13.4C1.8 11.2 3.9 9.6 6.5 9.6C7.3 9.6 8 9.7 8.7 10" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M12.2 8.6V13M10 10.8H14.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("user-remove") {
      <circle cx="6.5" cy="5.2" r="2.6" stroke="currentColor" stroke-width="1.3" />
      <path d="M1.8 13.4C1.8 11.2 3.9 9.6 6.5 9.6C7.3 9.6 8 9.7 8.7 10" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
      <path d="M10 10.8H14.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
    @case ("steering") {
      <circle cx="8" cy="8" r="6.2" stroke="currentColor" stroke-width="1.3" />
      <circle cx="8" cy="8" r="1.4" stroke="currentColor" stroke-width="1.3" />
      <path d="M1.9 7.2C4.2 7.9 5.6 7.9 6.6 7.9M14.1 7.2C11.8 7.9 10.4 7.9 9.4 7.9M8 9.4V14.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    }
  }
</svg>
